import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as r from "react";
var s = r.createContext(null);

function a() {
  return {
    groups: new Map(),
    get: function get(n, t) {
      var c;
      var e = this.groups.get(n);
      e || (e = new Map(), this.groups.set(n, e));
      var l = (c = e.get(t)) != null ? c : 0;
      e.set(t, l + 1);
      var o = Array.from(e.keys()).indexOf(t);

      function i() {
        var u = e.get(t);
        u > 1 ? e.set(t, u - 1) : e.delete(t);
      }

      return [o, i];
    }
  };
}

function C(_ref) {
  var n = _ref.children;
  var t = r.useRef(a());
  return r.createElement(s.Provider, {
    value: t
  }, n);
}

function d(n) {
  var t = r.useContext(s);
  if (!t) throw new Error("You must wrap your component in a <StableCollection>");

  var e = f(),
      _t$current$get = t.current.get(n, e),
      _t$current$get2 = _slicedToArray(_t$current$get, 2),
      l = _t$current$get2[0],
      o = _t$current$get2[1];

  return r.useEffect(function () {
    return o;
  }, []), l;
}

function f() {
  var l, o, i;
  var n = (i = (o = (l = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) == null ? void 0 : l.ReactCurrentOwner) == null ? void 0 : o.current) != null ? i : null;
  if (!n) return Symbol();
  var t = [],
      e = n;

  for (; e;) {
    t.push(e.index), e = e.return;
  }

  return "$." + t.join(".");
}

export { C as StableCollection, d as useStableCollectionIndex };